"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TilePictureSet = void 0;
exports.TilePictureSet = {
    Card: [
        { width: 334, maxWidth: 360 },
        { width: 574, maxWidth: 600 },
        { width: 693, maxWidth: 720 },
        { width: 486, maxWidth: 1024 },
    ],
    CardBig: [
        { width: 334, maxWidth: 360 },
        { width: 574, maxWidth: 600 },
        { width: 693, maxWidth: 720 },
        { width: 486, maxWidth: 1024 },
    ],
    Wide: [
        { width: 334, maxWidth: 360 },
        { width: 574, maxWidth: 720 },
    ],
    WideSmall: [
        { width: 334, maxWidth: 360 },
        { width: 574, maxWidth: 720 },
    ],
};
